import { TrackerType } from '@futrli/shared-services';
import { eventTracker } from '@futrli/tracking';

import { injector } from './injector';

export const getTracker = () => {
  return injector.get('Tracker') as TrackerType;
};

export const { trackCTA, trackEvent, trackViewModal } = eventTracker(getTracker);
